import { styled } from "@mui/material";

import { shouldForwardPropHelper } from "utils/shouldForwardPropHelper";

import type { ReactNode } from "react";

export interface DetailsLayoutProps {
  asideSection: ReactNode;
  header: ReactNode;
  mainSection: ReactNode;
}

export function DetailsLayout({
  header,
  asideSection,
  mainSection,
}: DetailsLayoutProps) {
  return (
    <>
      {header}
      <Wrapper isAsideSection={Boolean(asideSection)}>
        <MainSection>{mainSection}</MainSection>
        {asideSection && <AsideSection>{asideSection}</AsideSection>}
      </Wrapper>
    </>
  );
}

interface WrapperProps {
  isAsideSection: boolean;
}

const PROPS_SET = new Set(["isAsideSection"]);
const ASIDE_WIDTH = 347;

const Wrapper = styled("section", {
  shouldForwardProp: (prop) => shouldForwardPropHelper(prop, PROPS_SET),
})<WrapperProps>(({ theme, isAsideSection }) => ({
  display: "grid",
  gap: theme.spacing(4),
  gridTemplateColumns: isAsideSection ? `1fr ${ASIDE_WIDTH}px` : "1fr",

  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "1fr",
  },
}));

const AsideSection = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    order: 1,
  },
}));

const MainSection = styled("div")(({ theme }) => ({
  width: "100%",

  [theme.breakpoints.down("lg")]: {
    order: 2,
  },
}));
